/**
 * SimpleDialog — small modal used by OCR for Translate/Simplify/Lesson-plan
 * configuration. Extracted so the OCRScanner page stays focused on logic.
 */
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export default function SimpleDialog({ title, onClose, children }) {
  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4 tb-fade-in">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md tb-card p-6 tb-fade-up" role="dialog" aria-modal="true">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-lg font-medium tracking-tight">{title}</h3>
          <Button variant="ghost" size="icon" onClick={onClose} className="rounded-full" aria-label="Close">
            <X className="h-4 w-4" />
          </Button>
        </div>
        {children}
      </div>
    </div>
  );
}
